import { t } from '@lingui/core/macro';
import { Alert, Box } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { PickerBreadcrumbs } from '../PickerBreadcrumbs';
import { PickerDialog } from '../PickerDialog';
import { PickerFooter } from '../PickerFooter';
import { PickerHeader } from '../PickerHeader';
import { PickerLoaderOverlay } from '../PickerLoaderOverlay';
import { PickerTableFilesystem } from '../PickerTableFilesystem';
export function FileDialog(props) {
    const { fileLimit, dialogTitle, dialogSubtitle, submitLabel, selectedEntryAlert, multiselect = false, loaderOverlay, onClose, onSubmit, } = props;
    const { fileBrowserSearch, selected } = useFileBrowserContext();
    const { search, searchQuery, clearSearch } = fileBrowserSearch;
    const reachedFileLimit = Boolean(fileLimit && selected.length > fileLimit);
    const hasSelection = Boolean(selected.length);
    const disabledFooter = !hasSelection || reachedFileLimit;
    return (<PickerDialog>
      <PickerHeader title={dialogTitle} subtitle={dialogSubtitle} onClose={onClose} search={search} searchQuery={searchQuery} clearSearch={clearSearch}/>
      <PickerBreadcrumbs />
      {reachedFileLimit && (<Box display="block" px="2xl" mb="xl" width="100%">
          <Alert appearance="warning" title={t({ message: 'File limit reached', comment: 'File picker - File limit reached alert title' })} message={t({
                message: `You have reached the file limit of ${fileLimit} files.`,
                comment: 'File picker - File limit reached alert message',
            })}/>
        </Box>)}
      <PickerTableFilesystem selectedEntryAlert={selectedEntryAlert} multiselect={multiselect}/>
      <PickerFooter showPagination multiselect={multiselect} submitLabel={submitLabel} disabled={disabledFooter} onSubmit={onSubmit}/>
      {loaderOverlay && <PickerLoaderOverlay {...loaderOverlay}/>}
    </PickerDialog>);
}
